<template>
  <div>
    <ManageLiveStreamModal
      v-if="toggleLiveModal"
      :stream="getLiveStreamInformation()"
      @update:stream="onEditStream"
      :onClose="onToggleManageLiveStreamModal"/>
    <h5 class="section-title">{{$t('channel.creator.liveStream.title')}}</h5>
      <div class="live-url-container" v-for="(stream, index) in streams" :key="index">
        <div class="live-information-box">
          <div class="edit-button" @click="onClickEditStream(index)">
            <i class="fa fa-pencil" />
          </div>
          <div class="information-row">
            <label class="form-title mr-2">{{$t('common:name')}}: </label>
            <div>{{stream.name}}</div>
          </div>
          <div class="information-row">
            <label class="form-title mr-2">URL: </label>
            <div class="information">{{stream.manifestUrl}}</div>
          </div>
          <div class="information-row">
            <label class="form-title mr-2">{{$t('channel.creator.liveStream.resolution')}}: </label>
            <div>{{stream.resolution.width}} x {{stream.resolution.height}}</div>
          </div>
        </div>
      </div>
    <md-button
      class="md-raised"
      @click="onClickAddStream">
      + {{$t('channel.creator.liveStream.add')}}
    </md-button>
  </div>
</template>

<script>
import _ from 'lodash';
import ManageLiveStreamModal from '@/components/parts/channel/ManageLiveStreamModal.vue';

export default {
  components: {
    ManageLiveStreamModal,
  },
  props: {
    streams: {
      type: Array,
      default: () => [],
    },
    onUpdateStream: {
      type: Function,
      default: () => {},
    },
    onDeleteStream: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      toggleLiveModal: false,
      selectedIndex: null,
      isClickAddChannel: true,
    };
  },
  methods: {
    onToggleManageLiveStreamModal() {
      this.toggleLiveModal = !this.toggleLiveModal;
    },
    onClickAddStream() {
      this.isClickAddChannel = true;
      this.onToggleManageLiveStreamModal();
    },
    onClickEditStream(index) {
      this.isClickAddChannel = false;
      this.selectedIndex = index;
      this.onToggleManageLiveStreamModal();
    },
    getLiveStreamInformation() {
      if (this.isClickAddChannel) return null;
      return _.get(this.streams, `[${this.selectedIndex}]`, null);
    },
    onEditStream(newStreamData) {
      if (newStreamData) {
        this.onUpdateStream(newStreamData, this.selectedIndex);
      } else {
        this.onDeleteStream(this.selectedIndex);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/variables.scss';

.section-title {
  font-weight: bold;
  /* padding-bottom: $spacer; */
  /* border-bottom: 0.25px solid $gray-600; */
}

.live-information-box {
  position: relative;
  margin-top: $spacer;
  width: 100%;
  background-color: $dark-background-on-background;
  padding: $spacer * 1.5 $spacer;
  /* border: 0.25px solid $gray-500; */
  border-radius: 5px;
  .information-row {
    display: flex;
    margin-bottom: $spacer * 0.5;
    .information {
      width: 100%;
    }
  }
  .information-row:last-child {
    margin-bottom: 0;
  }

  .edit-button {
    position: absolute;
    right: $spacer * 0.75;
    top: $spacer * 0.75;
    cursor: pointer;
  }
}

.form-title {
  font-size: $font-size-base;
}

.add-button {
  width: 100%;
  margin-top: $spacer;
}

</style>
